import { ENV } from '../../config';

export interface PartnerK1Summary {
  entityId: number;
  partnerName: string;
  ownershipPct: number;
  incomeAllocated: number;
  status: string;
}

const BASE = `${ENV.API_URL}/api`;

function authHeaders(): HeadersInit {
  return {
    Authorization: `Bearer ${localStorage.getItem('token')}`,
    tenant: ENV.TENANT_ID ?? '',
  };
}

async function apiFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const r = await fetch(`${BASE}${path}`, {
    ...init,
    headers: { ...authHeaders(), ...(init?.headers ?? {}) },
  });
  if (!r.ok) {
    const err = await r.json().catch(() => ({}));
    throw Object.assign(new Error('API error'), { status: r.status, data: err });
  }
  return r.json();
}

export const k1Service = {
  getPartnerList(projectId: string | number): Promise<PartnerK1Summary[]> {
    return apiFetch<PartnerK1Summary[]>(`/k1/${projectId}/partner-list`);
  },
};
